module.exports = __webpack_public_path__ + "static/img/zoom-to.5361d3f0.svg";